module.exports = __webpack_public_path__ + "static/media/Currency Exchange.cb6a9545.svg";